import React from 'react';
import { connect } from 'react-redux';
import DatasetCards from '@/datasets/components/DatasetCards';
import { onCodeScroll } from '@/hooks/paging';
import RequestDatasetsContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../components/RequestDatasetsContainer';
import RequestDatasetsFilters from './RequestDatasetsFilters';

const RequestDatasetCards = ({
  canCreate,
  category,
  code,
  currentPage,
  datasets,
  fetchData,
  newDatasetCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
}) => (
  <RequestDatasetsContainer category={category} code={code} readStatus={readStatus} fetchData={fetchData}>
    <div className="sticky-panel-header">
      <RequestDatasetsFilters category={category} code={code} className="aridhia-list-filter" fluid />
    </div>
    <DatasetCards
      canCreate={canCreate}
      handleScroll={() => onCodeScroll(fetchData, category, code, currentPage, pageCount, pageSize)}
      items={datasets}
      itemsPerRow={1}
      newDatasetCode={newDatasetCode}
      onCheckBoxClick={(value) => onCheckBoxClick(category, code, value)}
      readErrors={readErrors}
      readStatus={readStatus}
      single
    />
  </RequestDatasetsContainer>
);

export default connect(mapStateToProps, mapDispatchToProps)(RequestDatasetCards);
